import { render, staticRenderFns } from "./SignaturePad.vue?vue&type=template&id=20b1036b&scoped=true"
import script from "./SignaturePad.vue?vue&type=script&lang=js"
export * from "./SignaturePad.vue?vue&type=script&lang=js"
import style0 from "./SignaturePad.vue?vue&type=style&index=0&id=20b1036b&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b1036b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/tomi/Projects/ingeniAR/rrhh/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20b1036b')) {
      api.createRecord('20b1036b', component.options)
    } else {
      api.reload('20b1036b', component.options)
    }
    module.hot.accept("./SignaturePad.vue?vue&type=template&id=20b1036b&scoped=true", function () {
      api.rerender('20b1036b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/SignaturePad.vue"
export default component.exports